export default "__VITE_ASSET__Begi1buz__"